module.exports = __webpack_public_path__ + "static/assets/2a9fc23517dab6acdf06709f8a22f5d5.png";